import React from 'react'
import { Field, reduxForm } from 'redux-form'
import TextField from 'material-ui/TextField'
import Button from 'material-ui/Button'
import { withStyles } from 'material-ui/styles'
import { FormControlLabel } from 'material-ui/Form'
import Checkbox from 'material-ui/Checkbox'

const styles = theme => ({
  formHorizontal: {
    display: 'flex',
    flexDirection: 'row'
  },
  formVertical: {
    display: 'flex',
    flexDirection: 'column'
  },
  passwordField: {
    flexGrow: 1,
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit
  },
  button: {
    marginLeft: theme.spacing.unit,
    alignSelf: 'center'
  }
})

const renderTextField = ({
  input,
  label,
  meta: { touched, error },
  ...custom
}) => <TextField label={label} {...input} {...custom} />

const renderCheckbox = ({
  input: { value: checked, ...input },
  label,
  meta: { touched, error },
  ...custom
}) => (
  <FormControlLabel
    control={<Checkbox checked={checked} {...input} {...custom} />}
    label={label}
  />
)

const DecryptPasswordForm = reduxForm({
  form: 'decryptPassword'
})(
  withStyles(
    styles
  )(({ classes, handleSubmit, submitting, wrongPassword, unlockPending }) => (
    <form className={classes.formVertical} onSubmit={handleSubmit}>
      <div className={classes.formHorizontal}>
        <Field
          name="keyPassword"
          type="password"
          component={renderTextField}
          error={wrongPassword}
          helperText={
            wrongPassword
              ? 'Wrong key password.'
              : "It won't be sent to any server."
          }
          placeholder="Key password"
          className={classes.passwordField}
          disabled={unlockPending || submitting}
        />
        <Button
          className={classes.button}
          color="primary"
          type="submit"
          disabled={unlockPending || submitting}
        >
          {submitting || unlockPending ? 'Unlocking…' : 'Unlock'}
        </Button>
      </div>
      <Field
        name="storeKeyPassword"
        component={renderCheckbox}
        label="Store key password in browser's local storage"
        disabled={unlockPending || submitting}
      />
    </form>
  ))
)

export default ({
  keyPassword,
  unlockPrivateKey,
  wrongPassword,
  unlockPending
}) => (
  <div>
    <DecryptPasswordForm
      unlockPending={unlockPending}
      onSubmit={values =>
        unlockPrivateKey({
          keyPassword: values.keyPassword,
          storeKeyPassword: values.storeKeyPassword
        })}
      wrongPassword={wrongPassword}
      initialValues={{ keyPassword, storeKeyPassword: keyPassword !== '' }}
    />
  </div>
)



// WEBPACK FOOTER //
// ./src/components/DecryptPasswordForm.js